import { useState, useEffect } from "react";
import { useRouter, withRouter } from "next/router";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import config from "../../config";
import * as FIXED from "../../config/constants";
import labels from "../../config/labels";
import types from "../../config/types";
import * as pageAPI from "../../services/pageService";
import ajaxservice from "../../utils/ajaxServices";
import {
  getFilterDealList,
  parseFilterQuery,
  getDealList,
  getDealsFilterByPageNumber,
  getSortQueryForDeals,
  getDealFilterByCategory,
  getDealFilterByPrice,
  getDealFilterByBrands,
  getDealFilterByPromotions,
  getDealFilterByContractType,
  getDealFilterByPlanType,
  getDealFilterByPlanName,
  getDealFilterByContractDuration,
  getDealFilterByVoiceMinutes,
  getDealFilterByAirTime,
  getDealFilterByRange,
  getDealFilterByData,
  getDealFilterBySubCategory,
  getDealFilterByAccessories,
  getDealsFilterBySort,
  resetFilter,
  resetDealsToPrice,
  getDealAggregations,
  getDealFilterByProductNames,
  getFilterCriteriaFromValue,
  getMinMaxFromFilterArray,
} from "../../services/filterDealService";
import {
  getFilteredCategories,
  getFilteredCategory,
} from "../../services/filterService";
import { getAllCategories } from "../../services/productListService";
import { BannerDetails } from "../../config/queries";
import {
  Row,
  Col,
  Container,
  CustomContainer,
  useDispatch,
} from "../../components/atoms/DependencyHelper";
import BrowseContainer from "../../components/organisms/BrowseContainer/BrowseContainer";
import DealGridSearchContainer from "../../components/organisms/dealGridSearchContainer/DealGridSearchContainer";
import DealGridListContainer from "../../components/organisms/dealGridListContainer/DealGridListContainer";
import ProductRangeContainer from "../../components/molecules/product-range-section/productRange";
import ButtonGroup from "../../components/molecules/buttonGroups/ButtonGroup";
import {
  dynamicBreadCrumb,
  showSpinner,
  getCurrentPageNumber,
  getCurrentSortVal,
  updatePathInBreadCrumb,
  formatBreadCrumb,
  updateSessionStorage,
  manipulateFilter,
  getDealExpiryTime,
  componentCheckSize,
} from "../../utils/helperServices";
import BreadCrumb from "../../components/atoms/breadCrumb/BreadCrumb";
import * as Analytics from "../../services/analyticsUtag";
import Seo from "../../components/atoms/Seo/Seo";
import { breadcrumbGenerator } from "../../services/breadcrumbService";
import UpgradeCheckBar from "../../components/atoms/upgradeCheckBar/upgradeCheckBar";
import {
  displayHideUpgradeModal,
  updateUpgradeRedirect,
  displayHideUpgradeTopbanner,
  updateJourneyStatus,
  updateSelectedData,
  updateDealsReset,
} from "../../Redux/actions/upgradeAction";
import { renderComponent } from "../../services/renderComponent";
import { SET_CREDIT_SELECTED_AFFORD_DEAL } from "../../Redux/actionTypes/index";
import AffordabilityFilterToggle from "../../components/organisms/AffordabilityFilterToggle/AffordabilityFilterToggle";
import { upgradeStages } from "../../services/upgradeService";
import {
  getAffordablePriceFilterDataFromOptions,
  getPriceFilterDataFromOptions,
  getNotAllowedRanges,
} from "../../utils/priceFilterUtils";
import { toggleFilters } from "../../Redux/actions/navAction";
import { Router } from "../../components/atoms/DependencyHelper";
import { forceCheck } from "react-lazyload";

const k8sConfig = typeof window === "undefined" ? require("config") : "";
let bannerDataFetched = false;

const DealGridPage = (props) => {
  const isTablet = componentCheckSize() <= 1024;
  const router = useRouter();
  const dispatch = useDispatch();
  const dynamicRoute = dynamicBreadCrumb();
  const [showComp, setShowComp] = useState(false);
  const [viewExecuted, setViewExecuted] = useState(false);
  const [sectionLvls, setSectionLvls] = useState({});
  const [bannerData, setBannerData] = useState([]);
  let [productList, setProductList] = useState({});
  let [productListLoaded, setProductListLoaded] = useState(false);
  let [selectedFilter, setSelectedFilter] = useState(props.selectedFilter);
  const [allBrands, setAllBrands] = useState([]);
  const [allPromotions, setAllPromotions] = useState([]);
  let [plantypes, setPlantypes] = useState([]);
  let [plannames, setPlannames] = useState([]);
  let [accessories, setAccessories] = useState([]);
  let [contractDuration, setContractDuration] = useState([]);
  let [contractType, setContractType] = useState([]);
  let [priceValue, setPriceValue] = useState({});
  let [sortProductsBy, setSortProductsBy] = useState(
    getCurrentSortVal(router.asPath, true)
  );
  let [featureSelected, setFeatureSelected] = useState("filter");
  let [isPageUpdated, setIsPageUpdated] = useState(false);
  let [updateContainer, setUpdateContainer] = useState(false);
  const [categoryList, setCategoryList] = useState({});
  const [contractsList, setContractsData] = useState([]);
  const [viewData, setViewData] = useState({});
  const [maxPrice, setMaxPrice] = useState(FIXED.MAX_MONTHLY_RECURRING);
  const [aggMaxPrice, setAggMaxPrice] = useState(0);
  const [aggMinPrice, setAggMinPrice] = useState(0);
  const [showQualifyDeals, setShowQualifyDeals] = useState(false);
  const [isProductsUpgrade, setIsProductsUpgrade] = useState(false);
  let [selectedCategory, setSelectedCategory] = useState(null);
  const [priceFilterData, setPriceFilterData] = useState([]);
  const [missingPriceFilterData, setMissingPriceFilterData] = useState([]);
  const [affordablePriceRange, setAffordablePriceRange] = useState([]);
  const [missingAffordablePriceRange, setMissingAffordablePriceRange] =
    useState([]);
  const [aggregators, setAggregators] = useState([]);
  const pageName = "shopping: deals grid: browse all deals";
  const [renderdEmpty, setRenderdEmpty] = useState(false);
  const [showFilterError, setFilterError] = useState(false);
  const [showFilterByProduct, setShowFilterByProduct] = useState(false);
  const [didMount, setDidMount] = useState(false);
  const [initAggregationsType, setInitAggregationsType] = useState("default");

  const isMobile = componentCheckSize() < FIXED.MOBILE_WIDTH;

  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  const legacyEnv = config.envConfigs[env].legacyEnv;

  const joinAllData = (array) => {
    const newKeys = [].concat.apply([], array);
    const allkeys = newKeys.join(",");
    return allkeys;
  };

  useEffect(() => {
    setDidMount(true);
    initAggregations();
    window.addEventListener("popstate", onBackButtonClick);
    return () => {
      window.removeEventListener("popstate", onBackButtonClick);
    };
  }, []);

  useEffect(() => {
    //Fetch updated max price in price filter based on selectedCategory MO-3427
    const curCategoryId = selectedFilter?.selectedCategory;
    if (curCategoryId && initAggregationsType == "default") {
      setInitAggregationsType("updated");
      initAggregations(true);
    }
  }, [selectedFilter?.selectedCategory]);

  const breadcrumbs = breadcrumbGenerator().deals.reverse();
  const setPageSiteLevel = () => {
    let section_lvls = {};
    let index = 0;
    for (let item of breadcrumbs) {
      index = index + 1;
      if (index > 4) break;
      section_lvls[`page_site_section_lvl_${index}`] = item.label;
    }
    return section_lvls;
  };

  const isEligible = () => {
    return (
      (props.upgradeChecksEnabled &&
        props?.upgrade?.upgradeCheckDone &&
        props?.upgrade?.upgradeResponse?.upgradeEligible &&
        props?.upgrade?.creditFilters?.total_monthly_payment) ||
      props.isShowAffordDeal
    );
  };

  const handleRangeChange = (val) => {
    let curRange = Number(val);
    const section_lvls = setPageSiteLevel();
    const total = categoryList?.categories ? categoryList.categories.length : 0;
    for (let i = 0; i < total; i++) {
      if (curRange === Number(categoryList.categories[i].id)) {
        if (Number(selectedCategory?.id) === curRange) {
          curRange = null;
        }

        Analytics.link({
          page_tool_event: "use",
          page_tool_name: "shopping: deals grid: deal range filter",
          filter_query: `${categoryList.categories[i].name}`,
          ...section_lvls,
          ...Analytics.getUtagData([
            "page_name",
            "page_channel",
            "channel_type",
            "page_master_tab",
            "visitor_login_status",
            "visitor_msisdn_hash",
            "visitor_customer_id",
            "visitor_id_hash",
            "visitor_subscription_type",
          ]),
        });
        break;
      }
    }
    setSelectedFilter({
      ...selectedFilter,
      ...{ selectedCategory: curRange },
    });
    getDealFilterByRange(curRange, showQualifyDeals).then(reloadPageData);
    return props?.handleProductRange && props.handleProductRange(curRange);
  };

  const toggleHandler = (btnClicked) => {
    setFeatureSelected(btnClicked);
    setShowComp(!showComp);
    props.toggleFilters(true);
    if (btnClicked.toLowerCase() === "search") {
      setShowFilterByProduct(true);
    } else {
      setShowFilterByProduct(false);
    }
  };

  const changeState = () => {
    setShowComp(!showComp);
  };

  const updateFilterCriteria = () => {
    if (selectedFilter.updateFilterCriteria || allBrands?.length === 0) {
      let plantypePresent = false;
      let plannamePresent = false;
      let accessoriesPresent = false;
      let contractDurationPresent = false;
      let contractTypePresent = false;

      if (productList && productList.products) {
        const aggregations = productList?.products?.aggregations;
        (aggregations || []).map((item) => {
          if (item.attribute_code.toLowerCase() === "plan_type") {
            setPlantypes(item.options);
            plantypePresent = true;
          }
          if (item.attribute_code.toLowerCase() === "plan_name") {
            setPlannames(item.options);
            plannamePresent = true;
          }
          if (item.attribute_code.toLowerCase() === "accessories") {
            setAccessories(item.options);
            accessoriesPresent = true;
          }
          if (item.attribute_code.toLowerCase() === "payment_terms") {
            setContractDuration(item.options);
            contractDurationPresent = true;
          }
          if (item.attribute_code.toLowerCase() === "contract_type") {
            setContractType(item.options);
            contractTypePresent = true;
          }
        });

        if (!plantypePresent) {
          setPlantypes([]);
        }
        if (!plannamePresent) {
          setPlannames([]);
        }
        if (!accessoriesPresent) {
          setAccessories([]);
        }
        if (!contractDurationPresent) {
          setContractDuration([]);
        }
        if (!contractTypePresent) {
          setContractType([]);
        }
      }
    }
  };

  const getCategoryGridData = async () => {
    const categoryListData = await getAllCategories(
      true,
      props?.defaultCategoryId
    );
    if (categoryListData && categoryListData.errors) {
      Analytics.link({
        page_name: pageName,
        page_form_event: "error",
        page_errors: `${
          categoryListData.errors[0] ? categoryListData.errors?.[0].message : ""
        }`,
        page_errors_code: `dlp-dxl-g-ac-${categoryListData.status}`,
      });
    }

    setCategoryList(categoryListData);
    return categoryListData;
  };

  const isFilterApplied = async (sortParam) => {
    showSpinner();
    let filter = await parseFilterQuery(
      decodeURIComponent(window.location.search)
    );
    if (filter.isShowQualifying) {
      setShowQualifyDeals(filter.isShowQualifying === "true");
      if (
        filter.isShowQualifying === "true" &&
        props?.upgrade?.creditFilters?.financeIndicator === "N"
      ) {
        filter.deviceInstallment = Number(
          props?.upgrade?.creditFilters?.deviceInstallment
        );
      }
    }

    if (filter?.monthly_recurring) {
      const { maxValue, minValue } = filter?.monthly_recurring || {};
      setPriceValue({
        minValue: minValue,
        maxValue: maxValue,
      });
    }

    if (
      JSON.stringify(filter) != JSON.stringify(selectedFilter) ||
      isPageUpdated
    ) {
      let productListData;
      setSelectedFilter((selectedFilter = filter));
      if (Object.keys(selectedFilter).length) {
        setProductListLoaded(false);
        productListData = await getFilterDealList(
          filter,
          sortParam,
          getCurrentPageNumber(router.asPath),
          labels.pagination_max_items_per_page
        );
        if (productListData) {
          setProductList(productListData);
          setProductListLoaded(true);
        }
        if (productListData?.contract_type_desc) {
          setContractsData(productListData?.contract_type_desc);
        }
      } else {
        setProductListLoaded(false);
        productListData = await getDealList(
          sortParam,
          getCurrentPageNumber(router.asPath),
          labels.pagination_max_items_per_page
        );
        if (productListData) {
          setProductList(productListData);
          setProductListLoaded(true);
        }
      }
      if (productListData && productListData.errors) {
        Analytics.link({
          page_name: pageName,
          page_form_event: "error",
          page_errors: `${
            productListData.errors[0] ? productListData.errors?.[0].message : ""
          }`,
          page_errors_code: `dlp-m-g-fd-${productListData.status}`,
        });
      }
    }
  };

  const loadPageData = () => {
    const currentSortVal = getCurrentSortVal(router.asPath, true);
    const sortParam = getSortQueryForDeals(currentSortVal);
    setSortProductsBy(currentSortVal);
    updatePathInBreadCrumb(router);
    isFilterApplied(sortParam);
  };

  const reloadPageData = () => {
    showSpinner();
    setIsPageUpdated(true);
  };

  const handleResetFilter = (type) => {
    if (type === "price") {
      if (isEligible()) {
        const curMaxPrice = getMaxPrice();
        const curPriceValue = {
          minValue: 0,
          maxValue: curMaxPrice,
        };
        setShowQualifyDeals(true);
        setMaxPrice(curMaxPrice);
        setPriceValue(curPriceValue);
        return getDealFilterByPrice({
          ...curPriceValue,
          isShowQualifying: "true",
          skipPageNumber: true,
        }).then(reloadPageData);
      } else {
        setMaxPrice(aggMaxPrice);
        setPriceValue({ minValue: 0, maxValue: aggMaxPrice });
        return getDealFilterByPrice({
          skipPageNumber: true,
          minValue: aggMinPrice,
          maxValue: aggMaxPrice,
        }).then(reloadPageData);
      }
    }

    if (isEligible()) {
      const curMaxPrice = getMaxPrice();
      setShowQualifyDeals(true);
      setMaxPrice(curMaxPrice);
      setPriceValue({
        minValue: 0,
        maxValue: curMaxPrice,
      });
      return resetDealsToPrice(
        "monthly_recurring",
        0,
        curMaxPrice,
        router
      ).then(reloadPageData);
    }
    setMaxPrice(aggMaxPrice);
    setPriceValue({ minValue: 0, maxValue: aggMaxPrice });
    if (!isMobile) {
      const section_lvls = setPageSiteLevel();
      Analytics.link({
        page_name: "shopping: deals grid: browse all deals",
        page_channel: "shopping",
        page_tool_event: "use",
        page_tool_name: `shopping: deals grid: browse all deals: reset all filters`,
        page_master_tab: "personal",
        ...section_lvls,
      });
    }
    return resetFilter().then(reloadPageData);
  };

  const handleBrandChange = (flag, brandObjObj, reload = true) => {
    const brandArr = getSelectedBrands(flag, brandObjObj);
    const selectedBrands = brandArr.map((brand) => brand.label);
    if (flag) {
      Analytics.link({
        page_tool_event: "use",
        page_tool_name: "shopping: deals grid: brand filter",
        filter_query: selectedBrands.toString(),
        ...viewData,
      });
    }
    if (reload) {
      getDealFilterByBrands(brandArr).then(reloadPageData);
    }
  };

  const getSelectedBrands = (flag, brandObjObj) => {
    const brandArr = manipulateFilter(
      flag,
      selectedFilter,
      brandObjObj,
      "brands"
    );
    setSelectedFilter({
      ...selectedFilter,
      ...{ brands: brandArr },
    });

    return brandArr;
  };

  const handlePromotionChange = (flag, promotionObj, reload = true) => {
    const promotionArr = getSelectedPromotion(flag, promotionObj);
    setSelectedFilter({
      ...selectedFilter,
      ...{ promotions: promotionArr },
    });

    if (flag) {
      Analytics.link({
        page_tool_event: "use",
        page_tool_name: "shopping: deals grid: promotions filter",
        filter_query: promotionObj?.label,
        ...viewData,
      });
    }
    if (reload) {
      getDealFilterByPromotions(promotionArr).then(reloadPageData);
    }
  };

  const getSelectedPromotion = (flag, promotionObj) => {
    const promotionArr = manipulateFilter(
      flag,
      selectedFilter,
      promotionObj,
      "promotions"
    );
    setSelectedFilter({
      ...selectedFilter,
      ...{ promotions: promotionArr },
    });

    return promotionArr;
  };

  const handleContractTypeChange = (flag, contractValue, reload = true) => {
    const ctypeArr = getSelectedContractType(flag, contractValue);
    if (flag) {
      Analytics.link({
        page_tool_event: "use",
        page_tool_name: "shopping: deals grid: contract type filter",
        filter_query: contractValue?.label,
        ...viewData,
      });
    }
    if (reload) {
      getDealFilterByContractType(ctypeArr).then(reloadPageData);
    }
  };

  const getSelectedContractType = (flag, contractValue) => {
    const ctypeArr = !flag ? [] : [contractValue];
    setSelectedFilter({
      ...selectedFilter,
      ...{ contracttype: ctypeArr },
    });
    return ctypeArr;
  };

  const handlePlanTypeChange = (flag, planTypeValue, reload = true) => {
    const planTypeArr = getSelectedPlanType(flag, planTypeValue);
    if (flag) {
      Analytics.link({
        page_tool_event: "use",
        page_tool_name: "shopping: deals grid: plan type filter",
        filter_query: planTypeValue?.label,
        ...viewData,
      });
    }
    if (reload) {
      getDealFilterByPlanType(planTypeArr).then(reloadPageData);
    }
  };

  const getSelectedPlanType = (flag, planTypeValue) => {
    const planTypeArr = manipulateFilter(
      flag,
      selectedFilter,
      planTypeValue,
      "plantypes"
    );
    setSelectedFilter({
      ...selectedFilter,
      ...{ plantypes: planTypeArr },
    });
    return planTypeArr;
  };

  const handlePlanNameChange = (flag, planNameValue, reload = true) => {
    const planNameArr = getSelectedPlanName(flag, planNameValue);
    if (flag) {
      Analytics.link({
        page_tool_event: "use",
        page_tool_name: "shopping: deals grid: plan name filter",
        filter_query: planNameValue?.label,
        ...viewData,
      });
    }
    if (reload) {
      getDealFilterByPlanName(planNameArr).then(reloadPageData);
    }
  };

  const getSelectedPlanName = (flag, planNameValue) => {
    const planNameArr = manipulateFilter(
      flag,
      selectedFilter,
      planNameValue,
      "plannames"
    );
    setSelectedFilter({
      ...selectedFilter,
      ...{ plannames: planNameArr },
    });
    return planNameArr;
  };

  const handleAccessoriesChange = (flag, accessoriesObj) => {
    const accessoriesArr = getSelectedAccessories(flag, accessoriesObj);
    getDealFilterByAccessories(accessoriesArr).then(reloadPageData);
    if (flag) {
      Analytics.link({
        page_tool_event: "use",
        page_tool_name: "shopping: deals grid: accessories filter",
        filter_query: accessoriesObj?.label,
        ...viewData,
      });
    }
  };

  const getSelectedAccessories = (flag, accessoriesObj) => {
    const accessoriesArr = manipulateFilter(
      flag,
      selectedFilter,
      accessoriesObj,
      "accessories"
    );
    setSelectedFilter({
      ...selectedFilter,
      ...{ accessories: accessoriesArr },
    });
    return accessoriesArr;
  };

  const handleContractDurationChange = (
    flag,
    contractdurationObj,
    reload = true
  ) => {
    const contractDurationArr = getSelectedContractDuration(
      flag,
      contractdurationObj
    );
    if (flag) {
      Analytics.link({
        page_tool_event: "use",
        page_tool_name: "shopping: deals grid: contract duration type filter",
        filter_query: contractdurationObj?.label,
        ...viewData,
      });
    }
    if (reload) {
      getDealFilterByContractDuration(contractDurationArr).then(reloadPageData);
    }
  };

  const getSelectedContractDuration = (flag, contractdurationObj) => {
    const contractDurationArr = manipulateFilter(
      flag,
      selectedFilter,
      contractdurationObj,
      "contractduration"
    );
    setSelectedFilter({
      ...selectedFilter,
      ...{ contractduration: contractDurationArr },
    });
    return contractDurationArr;
  };

  const handleCategoryChange = (category) => {
    getSelectedCategory(category);
    getDealFilterByCategory(category?.id, false, showQualifyDeals).then(
      reloadPageData
    );
  };

  const getSelectedCategory = (category) => {
    if (selectedCategory?.id !== category?.id) {
      setSelectedCategory((selectedCategory = category));
      updateCategoryOnFilter(category?.id);
      Analytics.link({
        page_tool_event: "use",
        page_tool_name: "shopping: deals grid: category filter",
        filter_query: category?.name,
        ...viewData,
      });
    } else {
      setSelectedCategory((selectedCategory = null));
    }
  };

  const handleSubCategoryChange = (flag, subCategoryObj) => {
    let subCategoryArr = (
      selectedFilter?.selectedSubCategory
        ? selectedFilter.selectedSubCategory
        : ""
    )
      ? [...selectedFilter.selectedSubCategory]
      : [];
    const isPresent = subCategoryArr.findIndex(
      (item) => Number(subCategoryObj.id) === Number(item)
    );

    if (isPresent === -1) {
      subCategoryArr.push(subCategoryObj.id.toString());
    } else {
      subCategoryArr.filter((item, index) => {
        if (Number(item) === Number(subCategoryObj.id)) {
          subCategoryArr.splice(index, 1);
        }
      });
    }

    setSelectedFilter({
      ...selectedFilter,
      ...{ selectedSubCategory: subCategoryArr },
    });
    getDealFilterBySubCategory(subCategoryArr, showQualifyDeals).then(
      reloadPageData
    );
    if (flag) {
      Analytics.link({
        page_tool_event: "use",
        page_tool_name:
          "shopping: deals grid: " + selectedCategory?.name + " filter",
        filter_query: subCategoryObj?.name,
        ...viewData,
      });
    }
  };

  const handleDataChange = async (value, reload = true, reset = false) => {
    let dataObj = await getSelectedData(value);
    Analytics.link({
      page_tool_event: "use",
      page_tool_name: "shopping: deals grid: data filter",
      filter_query: `${value.min || 0},${value.max || FIXED.MAX_DATA}`,
      ...viewData,
    });
    if (reload) {
      getDealFilterByData(reset ? {} : dataObj).then(reloadPageData);
    }
  };

  const getSelectedData = async (value) => {
    let dataObj = {
      minValue: value.min,
      maxValue: value.max,
    };

    let dtArr = await getFilterCriteriaFromValue(value);

    setSelectedFilter({
      ...selectedFilter,
      ...{ promo_data: dtArr },
    });
    return dataObj;
  };

  const onResetData = () => {
    handleDataChange(
      {
        min: 0,
        max: FIXED.MAX_DATA,
      },
      true,
      true
    );
  };

  const handleAirTimeChange = async (value, reload = true, reset = false) => {
    let airtimeObj = await getSelectedAirTime(value);
    Analytics.link({
      page_tool_event: "use",
      page_tool_name: "shopping: deals grid: airtime filter",
      filter_query: `${value.min || 0},${value.max || FIXED.MAX_AIRTIME}`,
      ...viewData,
    });
    if (reload) {
      getDealFilterByAirTime(reset ? {} : airtimeObj).then(reloadPageData);
    }
  };

  const getSelectedAirTime = async (value) => {
    let airtimeObj = {
      minValue: value.min,
      maxValue: value.max,
    };
    let dtArr = await getFilterCriteriaFromValue(value);

    setSelectedFilter({
      ...selectedFilter,
      ...{ airtime: dtArr },
    });
    return airtimeObj;
  };

  const onResetAirtime = () => {
    handleAirTimeChange(
      {
        min: 0,
        max: FIXED.MAX_AIRTIME,
      },
      true,
      true
    );
  };

  const handleVoiceMinutesChange = async (
    value,
    reload = true,
    reset = false
  ) => {
    let voiceObj = await getSelectedVoiceMinutes(value);
    Analytics.link({
      page_tool_event: "use",
      page_tool_name: "shopping: deals grid: voice filter",
      filter_query: `${value.min || 0},${value.max || FIXED.MAX_MINUTES}`,
      ...viewData,
    });
    if (reload) {
      getDealFilterByVoiceMinutes(reset ? {} : voiceObj).then(reloadPageData);
    }
  };

  const getSelectedVoiceMinutes = async (value) => {
    let voiceObj = {
      minValue: value.min,
      maxValue: value.max,
    };

    let dtArr = await getFilterCriteriaFromValue(value);

    setSelectedFilter({
      ...selectedFilter,
      ...{ minutes: dtArr },
    });
    return voiceObj;
  };

  const onResetMinutes = () => {
    handleVoiceMinutesChange(
      {
        min: 0,
        max: FIXED.MAX_MINUTES,
      },
      true,
      true
    );
  };

  const handlePriceChange = (value, reload = true, reset = false) => {
    let priceObj = getSelectedPrice(value);
    Analytics.link({
      page_tool_event: "use",
      page_tool_name: "shopping: deals grid: price filter",
      filter_query: `${priceObj.minValue || 0},${
        priceObj.maxValue || aggMaxPrice
      }`,
      ...viewData,
    });
    if (reload) {
      getDealFilterByPrice(reset ? {} : priceObj).then(reloadPageData);
    }
  };

  const getSelectedPrice = (value) => {
    const { min, max } = value || {};
    let priceObj = {
      type: types.TYPE_MONTHLY,
      minValue: min,
      maxValue: max,
      isShowQualifying: showQualifyDeals ? "true" : "false",
      skipPageNumber: true,
    };
    setPriceValue({ minValue: min, maxValue: max });
    return priceObj;
  };

  const onResetPrice = () => {
    handlePriceChange({
      min: 0,
      max: isEligible() && showQualifyDeals ? getMaxPrice() : aggMaxPrice,
    });
  };

  const handleSortBy = (flag, val) => {
    setSortProductsBy(val);
    getDealsFilterBySort(val).then(reloadPageData);
    if (flag) {
      Analytics.link({
        ...viewData,
        ...Analytics.getUtagData(["channel_type"]),
        page_tool_event: "use",
        page_tool_name: "shopping: deals grid: sort filter",
        filter_query: val,
      });
    }
  };

  const handleSeeDetailsClick = (item) => {
    const { categories } = item;

    let analyticsData = {
      link_type: "use",
      link_name: "shopping: deal grid: view deal details",
      sales_product_category: [
        categories && categories[0] && categories[0].name,
      ],
      sales_product_id: [item?.name],
      sales_product_price: [item?.monthly_recurring],
      sales_product_quantity: 1,
      sales_order_discount: [item?.save_monthly_recurring],
      sales_promo_name: [item?.promotion_tag_label],
      ...viewData,
    };
    if (item?.deal_end_date) {
      analyticsData.deal_expiry = getDealExpiryTime(item?.deal_end_date);
    }
    Analytics.link(analyticsData);
  };

  const handleProductFilterChange = (flag, productObj) => {
    const productArr = manipulateFilter(
      flag,
      selectedFilter,
      productObj,
      "search"
    );
    const brandArr = manipulateFilter(
      flag,
      selectedFilter,
      { label: productObj.brandName, value: productObj.brandId },
      "brands"
    );
    setSelectedFilter({
      ...selectedFilter,
      ...{ search: productArr },
    });
    if (productObj.brandId != "" && productObj.brandName != "") {
      setSelectedFilter({
        ...selectedFilter,
        ...{ brands: brandArr },
      });
    }
    if (flag) {
      getDealFilterByProductNames(productArr, brandArr).then(reloadPageData);
    } else {
      getDealFilterByProductNames(productArr).then(reloadPageData);
    }
    const selectedProducts = productArr.map((product) => product.label);
    if (flag) {
      Analytics.link({
        page_name: "shopping: deals grid: filter by product",
        search_event: "search",
        search_terms: selectedProducts.toString(),
        search_category: "product search",
        search_type: "full searches",
        search_results: productList.products.total_count,
        ...viewData,
      });
    }
  };

  const handleProductFilterError = (value) => {
    setFilterError(value);
  };

  const filteredCategory = getFilteredCategory(selectedFilter, categoryList);
  const filteredCategories = getFilteredCategories(
    selectedFilter,
    categoryList
  );

  const doAnUpgradeCheck = () => {
    Analytics.link({
      page_name: pageName,
      page_tool_event: "use",
      page_tool_name: `${pageName}: do an upgrade check`,
    });
    if (props?.upgradeChecksEnabled) {
      props.updateUpgradeRedirect("", labels.upgrade.lbl_see_deals_btn);
      if (props.userLoggedIn) {
        if (props.eligibleUpgradeList.length > 1) {
          props.updateJourneyStatus(null, upgradeStages.ELIGIBLE_NUMBER_SELECT);
        } else if (props.eligibleUpgradeList.length == 1) {
          props.updateJourneyStatus(
            props.eligibleUpgradeList[0].resultCode,
            upgradeStages.UPGRADE_RESULT
          );
          props.updateSelectedData(props.eligibleUpgradeList[0]);
        }
      }
      props.displayHideUpgradeModal(true);
    } else {
      router.push(
        `https://www${legacyEnv}.vodacom.co.za/cloud/shopping/upgrades-check`
      );
    }
  };

  const getMaxPrice = () => {
    if (isEligible()) {
      if (props?.upgrade?.creditFilters?.financeIndicator) {
        const total_monthly_payment =
          Number(props?.upgrade?.creditFilters?.total_monthly_payment) || 0;
        if (total_monthly_payment > aggMaxPrice) {
          return aggMaxPrice;
        } else {
          return total_monthly_payment.toFixed();
        }
      } else {
        return aggMaxPrice;
      }
    } else {
      return aggMaxPrice;
    }
  };

  const handleShowQualifyDeals = (flag) => {
    if (props.isShowAffordDeal) {
      dispatch({
        type: SET_CREDIT_SELECTED_AFFORD_DEAL,
        payload: flag,
      });
    }

    if (!flag) {
      setMaxPrice(aggMaxPrice);
      setPriceValue({
        minValue: aggMinPrice,
        maxValue: aggMaxPrice,
      });
      setShowQualifyDeals(false);
      setSelectedFilter({
        ...selectedFilter,
        ...{ isShowQualifying: "false" },
      });
      getDealFilterByPrice({
        minValue: aggMinPrice,
        maxValue: aggMaxPrice,
        isShowQualifying: "false",
        skipPageNumber: true,
      }).then(reloadPageData);
      Analytics.link({
        page_name: pageName,
        page_tool_event: "use",
        page_tool_name: `${pageName}: deselect deals I qualify for`,
      });
    } else {
      Analytics.link({
        page_name: pageName,
        page_tool_event: "use",
        page_tool_name: `${pageName}: select deals I qualify for`,
      });
      const curMaxPrice = getMaxPrice();
      setMaxPrice(Number(curMaxPrice));
      setPriceValue({
        minValue: affordablePriceRange.length
          ? affordablePriceRange[0]
          : aggMinPrice,
        maxValue: curMaxPrice,
      });
      setShowQualifyDeals(true);
      setSelectedFilter({
        ...selectedFilter,
        ...{ isShowQualifying: "true" },
      });
      getDealFilterByPrice({
        minValue: affordablePriceRange.length
          ? affordablePriceRange[0]
          : aggMinPrice,
        maxValue: curMaxPrice,
        isShowQualifying: "true",
        skipPageNumber: true,
      }).then(reloadPageData);
    }

    setShowQualifyDeals(flag);
  };

  const updateCurrentPage = (page) => {
    getDealsFilterByPageNumber(page).then(reloadPageData);
  };

  const clearCategorieFilters = () => {
    setUpdateContainer(true);
  };

  useEffect(() => {
    updateSessionStorage("deals", router.asPath);
    reloadPageData();
  }, [router]);

  useEffect(() => {
    updateFilterCriteria();
  }, [productList?.products?.aggregations]);

  useEffect(() => {
    Analytics.setAutoTagging(false);
    if (
      productListLoaded &&
      Object.keys(dynamicRoute).length &&
      !viewExecuted &&
      !props.profileLoading &&
      Object.keys(selectedFilter).length &&
      Object.keys(selectedFilter).length > 1
    ) {
      const section_lvls = setPageSiteLevel();
      const userMetaData = Analytics.getProfileData(
        props.userLoggedIn,
        props.profileData
      );
      if (
        productList &&
        productList.products &&
        productList.products.items &&
        productList.products.items.length
      ) {
        Analytics.view({
          page_event: "view",
          page_name: pageName,
          page_channel: "shopping",
          channel_type: "Monthly",
          page_master_tab: "personal",
          ...section_lvls,
          ...userMetaData,
        });
        setViewData({
          page_name: pageName,
          page_channel: "shopping",
          channel_type: "Monthly",
          page_master_tab: "personal",
          ...section_lvls,
          ...userMetaData,
        });
      } else {
        Analytics.view({
          page_event: "view",
          page_name: pageName,
          page_form_event: "error",
          channel_type: "Monthly",
          page_errors:
            "We couldn't find any results for your selected filters. Try widen your search by changing some of your selections, or reset all filters below.",
          page_channel: "shopping",
          page_master_tab: "personal",
          ...sectionLvls,
          ...userMetaData,
        });
        setViewData({
          page_name: pageName,
          channel_type: "Monthly",
          page_channel: "shopping",
          page_master_tab: "personal",
          ...sectionLvls,
          ...userMetaData,
        });
      }
      setViewExecuted(true);
      setSectionLvls(section_lvls);
    }
  }, [
    productListLoaded,
    props.profileLoading,
    props.userLoggedIn,
    props.profileData,
  ]);

  useEffect(() => {
    props.toggleFilters(false);
  }, []);

  useEffect(() => {
    const selectedPromotionsData =
      selectedFilter?.promotions?.map((item) => item.value) || [];
    const selectedBrandsData =
      selectedFilter?.brands?.map((item) => item.value) || [];
    async function getBannerData() {
      bannerDataFetched = true;
      const bannerResult = await ajaxservice.fetchGraphQLGetRequest(
        BannerDetails,
        {
          grid: props.gridId,
          brand: `${joinAllData(selectedBrandsData)}`,
          promotion: `${joinAllData(selectedPromotionsData)}`,
        }
      );
      if (bannerResult) {
        setBannerData(bannerResult?.banners || []);
        if (bannerResult.errors) {
          Analytics.link({
            page_name: pageName,
            page_form_event: "error",
            page_errors: `${
              bannerResult.errors[0] ? bannerResult.errors?.[0].message : ""
            }`,
            page_errors_code: `dlp-m-g-bd-${bannerResult.status}`,
          });
        }
      }
    }

    if (props?.gridId) {
      if (selectedBrandsData?.length > 1) {
        setBannerData([]);
      } else {
        if (!bannerDataFetched) getBannerData();
      }
    }
  }, [selectedFilter?.promotions, selectedFilter?.brands, props?.gridId]);

  useEffect(() => {
    const curCategoryId =
      selectedFilter?.selectedCategory || selectedFilter?.selectedProductRange;
    if (categoryList && curCategoryId) {
      categoryList?.categories?.map((category) => {
        if (Number(category.id) === Number(curCategoryId)) {
          setSelectedCategory((selectedCategory = category));
        }
      });
    } else {
      setSelectedCategory((selectedCategory = null));
    }
  }, [
    categoryList,
    selectedFilter?.selectedCategory,
    selectedFilter?.selectedProductRange,
  ]);

  useEffect(() => {
    if (showComp) {
      window.scrollTo(0, 0);
    }
    props.displayHideUpgradeTopbanner(!showComp);
  }, [showComp]);

  useEffect(() => {
    let curMaxPrice = getMaxPrice(),
      curMin = 0,
      curMax = curMaxPrice;
    showSpinner();

    if (curMaxPrice) {
      parseFilterQuery(decodeURIComponent(window.location.search)).then(
        (filter) => {
          getCategoryGridData().then((categoriesData) => {
            let categoryIdByName;
            categoriesData?.categories?.map((item) => {
              if (props?.categoryName === item.name) {
                categoryIdByName = item.id;
              }
            });
            setSelectedFilter(filter);
            let priceObj = {
              minValue: Number(curMin),
              maxValue: Number(curMax),
            };
            if (filter?.monthly_recurring) {
              const { maxValue, minValue } = filter?.monthly_recurring || {};
              priceObj.maxValue = maxValue;
              priceObj.minValue = minValue;
            }
            setMaxPrice(Number(curMaxPrice));
            setPriceValue(priceObj);
            if (isEligible()) {
              initAggregationsMaxPrice(
                props?.upgrade?.creditFilters?.total_monthly_payment
              );
              setShowQualifyDeals(
                filter?.isShowQualifying == "false" ? false : true
              );
              getDealFilterByPrice({
                minValue: priceObj.minValue,
                maxValue: priceObj.maxValue,
                type: types.TYPE_MONTHLY,
                isShowQualifying: filter?.isShowQualifying
                  ? filter?.isShowQualifying
                  : "true",
                skipPageNumber: false,
              }).then(reloadPageData);
            } else {
              if (props?.upgrade?.msisdn) {
                curMaxPrice = aggMaxPrice;
              }
              if (isEligible() && affordablePriceRange.length == 0) {
                initAggregationsMaxPrice(
                  props?.upgrade?.creditFilters?.total_monthly_payment
                );
              }
              setShowQualifyDeals(false);
              if (!isEligible() && Object.keys(filter).length === 1) {
                getDealFilterByCategory(categoryIdByName).then(reloadPageData); // DCEC-10254 - for performance ticket -> on page load by default phone & sim category will be selected
              } else if (!isEligible() && filter?.isShowQualifying == "true") {
                resetFilter().then(reloadPageData);
              } else {
                setIsPageUpdated(true);
              }
            }
          });
        }
      );
    }
  }, [priceFilterData]);

  useEffect(() => {
    if (isEligible() && !isProductsUpgrade && didMount) {
      if (Object.keys(props?.upgrade?.creditFilters).length)
        setIsProductsUpgrade(true);
      let newpriceObj = {
        minValue: 0,
        maxValue: Number(getMaxPrice()),
      };
      initAggregationsMaxPrice(
        props?.upgrade?.creditFilters?.total_monthly_payment
      );
      setMaxPrice(Number(getMaxPrice()));
      setPriceValue(newpriceObj);
      setShowQualifyDeals(true);
      getDealFilterByPrice({
        minValue: newpriceObj.minValue,
        maxValue: newpriceObj.maxValue,
        type: types.TYPE_MONTHLY,
        isShowQualifying: "true",
        skipPageNumber: false,
      }).then(reloadPageData);
    }
  }, [
    props.upgrade?.upgradeCheckDone,
    props.upgrade?.selectedUpgradeResponse,
    props.upgrade?.creditFilters.financeIndicator,
  ]);

  const onBackButtonClick = () => {
    if (!isPageUpdated) setIsPageUpdated(true);
  };

  useEffect(() => {
    if (isPageUpdated) {
      setIsPageUpdated(false);
      loadPageData();
      setTimeout(forceCheck, 1000);
    }
  }, [isPageUpdated]);

  useEffect(() => {
    const section_lvls = setPageSiteLevel();
    if (
      productList &&
      productList.products &&
      productList.products.items &&
      productList.products.items.length
    ) {
      setRenderdEmpty(false);
    } else {
      if (
        !renderdEmpty &&
        productList &&
        productList.products &&
        productList.products.total_count == 0
      ) {
        Analytics.link({
          page_name: pageName,
          page_form_event: "error",
          page_errors:
            "We couldn't find any results for your selected filters. Try widen your search by changing some of your selections, or reset all filters below.",
          page_channel: "shopping",
          page_master_tab: "personal",
          ...section_lvls,
        });
        setRenderdEmpty(true);
      }
    }
  }, [productList]);

  const initAggregations = async (callFunc = false) => {
    // find price aggregation
    if (!priceFilterData || priceFilterData?.length == 0 || callFunc) {
      const products = await getDealAggregations({
        selectedFilter,
      });
      const priceAggregation = products?.products?.aggregations?.find(
        (agg) => agg.attribute_code === "monthly_recurring_bucket" || agg.attribute_code === "monthly_recurring"
      );
      const brandAggregation = products?.products?.aggregations?.find(
        (agg) => agg.attribute_code === "manufacturer"
      )?.options;
      const promotionAggregation = products?.products?.aggregations?.find(
        (agg) => agg.attribute_code === "promotion_tag"
      )?.options;
      updateFilters({ brandAggregation, promotionAggregation });

      if (priceAggregation) {
        const localPriceFilterData = getPriceFilterDataFromOptions(
          priceAggregation?.options ?? []
        );
        const getNotAllowedRangesData = getNotAllowedRanges(
          priceAggregation?.options || []
        );
        if (localPriceFilterData.length) {
          setAggMaxPrice(localPriceFilterData[localPriceFilterData.length - 1]);
          setMaxPrice(localPriceFilterData[localPriceFilterData.length - 1]);
          setAggMinPrice(localPriceFilterData[0]);
        }
        setPriceFilterData(localPriceFilterData);
        setMissingPriceFilterData(getNotAllowedRangesData);
      }
      if (products) {
        setAggregators(products?.products?.aggregations);
      }
    }
  };

  const initAggregationsMaxPrice = async (maxPriceValue) => {
    // find price aggregation for affordability
    if (maxPriceValue) {
      const products = await getDealAggregations({
        selectedFilter,
        maxPrice: Number(maxPriceValue),
      });
      const priceAggregation = products?.products?.aggregations?.find(
        (agg) => agg.attribute_code === "monthly_recurring_bucket" || "monthly_recurring"
      );
      const brandAggregation = products?.products?.aggregations?.find(
        (agg) => agg.attribute_code === "manufacturer"
      )?.options;
      const promotionAggregation = products?.products?.aggregations?.find(
        (agg) => agg.attribute_code === "promotion_tag"
      )?.options;

      if (priceAggregation) {
        const localPriceFilterData = getPriceFilterDataFromOptions(
          priceAggregation?.options || []
        );

        const affordablePriceFilterData =
          getAffordablePriceFilterDataFromOptions(
            localPriceFilterData,
            Number(maxPriceValue),
            aggMaxPrice
          );
        const getNotAllowedRangesData = getNotAllowedRanges(
          priceAggregation?.options || []
        );
        setAffordablePriceRange(affordablePriceFilterData);
        setMissingAffordablePriceRange(getNotAllowedRangesData);
      }

      updateFilters({ brandAggregation, promotionAggregation });
    }
  };

  const updateCategoryOnFilter = (categoryId) => {
    const tempSelectedFilter = { ...selectedFilter };
    for (const key in tempSelectedFilter) {
      if (
        key != "updateFilterCriteria" &&
        key != "isShowQualifying" &&
        key != "monthly_recurring"
      ) {
        delete tempSelectedFilter[key];
      }
    }

    if (!categoryId) {
      setSelectedFilter(...tempSelectedFilter);
    } else {
      setSelectedFilter({
        ...tempSelectedFilter,
        ...{ selectedCategory: categoryId },
      });
    }
  };

  const handleApplyFilter = (newSelectedFilters = selectedFilter || {}) => {
    const {
      selectedCategory,
      brands,
      promotions,
      contractduration,
      contracttype,
      plannames,
      plantypes,
      promo_data,
      minutes,
      airtime,
      search,
    } = newSelectedFilters;

    const { minValue, maxValue } = priceValue || {};
    let filterHref = "";
    let str = "";

    if (selectedCategory) {
      str = getDealFilterByCategory(selectedCategory, true); //true-return href, false-router push
      if (str && str !== "") {
        filterHref += str;
      }
    }

    if (brands) {
      str = getDealFilterByBrands(brands, true); //true-return href, false-router push
      if (str && str !== "") {
        filterHref += filterHref == "" ? str : `&${str}`;
      }
    }

    if (promotions) {
      str = getDealFilterByPromotions(promotions, true);
      if (str && str !== "") {
        filterHref += filterHref == "" ? str : `&${str}`;
      }
    }

    if (contractduration) {
      str = getDealFilterByContractDuration(contractduration, true);
      if (str && str !== "") {
        filterHref += filterHref == "" ? str : `&${str}`;
      }
    }

    if (contracttype) {
      str = getDealFilterByContractType(contracttype, true);
      if (str && str !== "") {
        filterHref += filterHref == "" ? str : `&${str}`;
      }
    }

    if (plannames) {
      str = getDealFilterByPlanName(plannames, true);
      if (str && str !== "") {
        filterHref += filterHref == "" ? str : `&${str}`;
      }
    }

    if (plantypes) {
      str = getDealFilterByPlanType(plantypes, true);
      if (str && str !== "") {
        filterHref += filterHref == "" ? str : `&${str}`;
      }
    }

    if (promo_data) {
      let promoVal = getMinMaxFromFilterArray(promo_data);
      let dataObj = {
        minValue: promoVal.minValue,
        maxValue: promoVal.maxValue,
      };
      str = getDealFilterByData(dataObj, true);
      if (str && str !== "") {
        filterHref += filterHref == "" ? str : `&${str}`;
      }
    }

    if (minutes) {
      let minutesVal = getMinMaxFromFilterArray(minutes);
      let dataObj = {
        minValue: minutesVal.minValue,
        maxValue: minutesVal.maxValue,
      };
      str = getDealFilterByVoiceMinutes(dataObj, true);
      if (str && str !== "") {
        filterHref += filterHref == "" ? str : `&${str}`;
      }
    }

    if (airtime) {
      let airtimeVal = getMinMaxFromFilterArray(airtime);
      let dataObj = {
        minValue: airtimeVal.minValue,
        maxValue: airtimeVal.maxValue,
      };
      str = getDealFilterByAirTime(dataObj, true);
      if (str && str !== "") {
        filterHref += filterHref == "" ? str : `&${str}`;
      }
    }

    if (search) {
      str = getDealFilterByProductNames(search, [], true);
      if (str && str !== "") {
        filterHref += filterHref == "" ? str : `&${str}`;
      }
    }

    if (Object.keys(priceValue).length !== 0) {
      let priceObj = {
        type: types.TYPE_MONTHLY,
        minValue: minValue,
        maxValue: maxValue,
        skipPageNumber: true,
      };
      str = getDealFilterByPrice(priceObj, true);
      if (str && str !== "") {
        filterHref += filterHref == "" ? str : `&${str}`;
      }
    }

    if (filterHref !== "") {
      filterHref = showQualifyDeals
        ? `${filterHref}&isShowQualifying=true`
        : `${filterHref}&isShowQualifying=false`;
      const newHref = filterHref
        ? `${types.DEAL_GRID_PAGE}?${filterHref}`
        : types.DEAL_GRID_PAGE;
      Router.push(types.DEAL_GRID_PAGE, newHref, { shallow: true }).then(
        reloadPageData
      );
    }
  };

  const getStatusFilter = (filter, disabled = false) => {
    return { ...filter, disabled };
  };

  const updateFilters = ({
    brandAggregation = [],
    promotionAggregation = [],
  }) => {
    if (brandAggregation?.length) {
      if (allBrands.length) {
        setAllBrands(
          allBrands.map((brand) => {
            if (
              brandAggregation.findIndex(
                (newBrand) => newBrand.value === brand.value
              ) > -1
            ) {
              return { ...brand, disabled: false };
            } else {
              return { ...brand, disabled: true };
            }
          })
        );
      } else {
        setAllBrands(brandAggregation?.map((brand) => getStatusFilter(brand)));
      }
    } else {
      if (allBrands.length) {
        setAllBrands(allBrands?.map((brand) => getStatusFilter(brand, true)));
      }
    }
    if (promotionAggregation?.length) {
      if (allPromotions.length) {
        setAllPromotions(
          allPromotions.map((promotion) => {
            if (
              promotionAggregation.findIndex(
                (newPromotion) => newPromotion.value === promotion.value
              ) > -1
            ) {
              return { ...promotion, disabled: false };
            } else {
              return { ...promotion, disabled: true };
            }
          })
        );
      } else {
        setAllPromotions(
          promotionAggregation?.map((promotion) => getStatusFilter(promotion))
        );
      }
    } else {
      setAllPromotions(
        allPromotions?.map((promotion) => getStatusFilter(promotion, true))
      );
    }
  };

  const updateAggregations = async ({ minPrice, maxPrice }) => {
    if (maxPrice) {
      const products = await getDealAggregations({
        selectedFilter,
        maxPrice,
        minPrice,
      });

      const brandAggregation = products?.products?.aggregations?.find(
        (agg) => agg.attribute_code === "manufacturer"
      )?.options;
      const promotionAggregation = products?.products?.aggregations?.find(
        (agg) => agg.attribute_code === "promotion_tag"
      )?.options;

      updateFilters({ brandAggregation, promotionAggregation });
    }
  };

  useEffect(() => {
    const curCategoryId =
      selectedFilter?.selectedCategory || selectedFilter?.selectedProductRange;

    if (curCategoryId && priceValue?.maxValue && allBrands?.length) {
      updateAggregations({
        minPrice: priceValue.minValue,
        maxPrice: priceValue.maxValue,
      });
    }
  }, [
    priceValue,
    selectedFilter?.selectedCategory,
    selectedFilter?.selectedProductRange,
  ]);

  return (
    <>
      <Seo
        title={props?.metadata?.title}
        content={props?.metadata?.description}
        url={props?.metadata?.canonical_url}
        keywords={props?.metadata?.keywords}
        robots={props?.metadata?.robots}
      />
      <CustomContainer id="product-list-container" className="main-container">
        <Container className={`custom-container ${showComp ? "hide" : ""}`}>
          <Row>
            <Col md={12}>
              <BreadCrumb
                list={formatBreadCrumb(breadcrumbGenerator().deals)}
              ></BreadCrumb>
            </Col>
          </Row>

          <Row>
            {categoryList &&
            categoryList.categories &&
            categoryList.categories.length ? (
              <Col md={12}>
                <ProductRangeContainer
                  selectedFilter={selectedFilter}
                  categoryList={categoryList?.categories}
                  handleContainer={handleRangeChange}
                  handleSelected={handleRangeChange}
                  heading={labels.lbl_deal_range}
                  page="deal-grid"
                  emptyCategories={updateContainer}
                />
              </Col>
            ) : (
              ""
            )}
          </Row>

          <Row>
            <Col id="deal-page-button-group">
              <BrowseContainer
                isDeal
                selectionFlag={
                  filteredCategory && Object.keys(filteredCategory.length !== 0)
                }
                heading={
                  filteredCategory && filteredCategory.name
                    ? filteredCategory.name
                    : labels.BreadCrumbLabels.lbl_browse_all_deals
                }
                shortDescription={
                  filteredCategory && filteredCategory.short_description
                    ? filteredCategory.short_description
                    : labels.lbl_filter_text
                }
                filterButton={
                  !showComp &&
                  isTablet && (
                    <CustomContainer className="filter-btn-group deal-page-button">
                      <Row>
                        <Col md={12} className="spacing">
                          <CustomContainer className="deal-filter-button-group-container">
                            {props.productSearchOnDealGridEnabled && (
                              <CustomContainer className="deal-filter-button-group deal-button-group-spacing">
                                <ButtonGroup
                                  toggleComps={(val) => {
                                    toggleHandler(val);
                                  }}
                                  noShadow={true}
                                  hide={showComp}
                                  selectedSortVal={
                                    sortProductsBy !== ""
                                      ? sortProductsBy
                                      : labels.sortKeys.lbl_recommended
                                  }
                                  buttonLabel={labels.lbl_filter_device_mobile}
                                  filterType="search"
                                />
                              </CustomContainer>
                            )}
                            <CustomContainer className="deal-filter-button-group">
                              <ButtonGroup
                                headingName="Filter Deals"
                                toggleComps={(val) => {
                                  toggleHandler(val);
                                }}
                                noShadow={true}
                                hide={showComp}
                                selectedSortVal={
                                  sortProductsBy !== ""
                                    ? sortProductsBy
                                    : labels.sortKeys.lbl_recommended
                                }
                                buttonLabel={labels.lbl_more_filters}
                              />
                            </CustomContainer>
                          </CustomContainer>
                        </Col>
                      </Row>
                    </CustomContainer>
                  )
                }
              />
            </Col>
          </Row>

          <CustomContainer>
            {isEligible() && (
              <>
                <Row>
                  <Col>
                    <UpgradeCheckBar
                      type={props.isShowAffordDeal ? "success" : "info"}
                      className="ecom-upgrade-banner"
                      message={
                        props.isShowAffordDeal
                          ? labels.creditVetting.lbl_available_deals
                          : labels.product_affordability.lbl_available_deals
                      }
                    />
                  </Col>
                </Row>

                <Row className="d-block d-lg-none">
                  <Col>
                    <AffordabilityFilterToggle
                      id="chk_qualify_deals"
                      checkboxLabel={
                        props.isShowAffordDeal
                          ? labels.creditVetting.lbl_qualify
                          : labels.product_affordability.lbl_qualify
                      }
                      checkboxSubtext={props?.upgrade?.creditFilters?.message}
                      handleCheck={handleShowQualifyDeals}
                      check={showQualifyDeals}
                    />
                  </Col>
                </Row>
              </>
            )}
            {showFilterError && (
              <Row className="d-block d-lg-none">
                <Col md={12}>
                  <CustomContainer className="deals-filter-error-message">
                    <img
                      src={`${imagePrefix}/assets/images/warning-black.svg`}
                      width={17}
                      height={17}
                      className="deals-filter-error-image"
                    />
                    <span> {labels.errors.lbl_deals_filter_error}</span>
                  </CustomContainer>
                </Col>
              </Row>
            )}
          </CustomContainer>
          {!props?.upgrade?.upgradeCheckDone && !props.isShowAffordDeal && (
            <Row className="d-block d-lg-none mb-3 mt-3">
              <Col>
                <UpgradeCheckBar
                  id="doAnUpgrade"
                  message={labels.upgrade.lbl_here_to_do_upgrade}
                  btnLabel={labels.upgrade.lbl_do_upgrade}
                  btnHandler={doAnUpgradeCheck}
                />
              </Col>
            </Row>
          )}
        </Container>

        <Container className="custom-container">
          {!showComp && isMobile && (
            <CustomContainer className="filter-btn-group">
              <Row>
                <Col md={12} className="spacing">
                  <CustomContainer className="deal-filter-button-group-container">
                    {props.productSearchOnDealGridEnabled && (
                      <CustomContainer className="deal-filter-button-group deal-button-group-spacing col-md-6 pl-0 pr-0">
                        <ButtonGroup
                          toggleComps={(val) => {
                            toggleHandler(val);
                          }}
                          hide={showComp}
                          noShadow={true}
                          selectedSortVal={
                            sortProductsBy !== ""
                              ? sortProductsBy
                              : labels.sortKeys.lbl_recommended
                          }
                          buttonLabel={labels.lbl_filter_device_mobile}
                          filterType="search"
                          productSearchOnDealGridEnabled={
                            props.productSearchOnDealGridEnabled
                          }
                        />
                      </CustomContainer>
                    )}
                    <CustomContainer className="deal-filter-button-group col-md-6 pl-0 pr-0">
                      <ButtonGroup
                        headingName="Filter Deals"
                        toggleComps={(val) => {
                          toggleHandler(val);
                        }}
                        hide={showComp}
                        noShadow={true}
                        selectedSortVal={
                          sortProductsBy !== ""
                            ? sortProductsBy
                            : labels.sortKeys.lbl_recommended
                        }
                        buttonLabel={labels.lbl_more_filters}
                      />
                    </CustomContainer>
                  </CustomContainer>
                </Col>
              </Row>
            </CustomContainer>
          )}
          <CustomContainer className="d-none d-lg-block">
            {showFilterError && (
              <Row>
                <Col lg={12}>
                  <CustomContainer className="deals-filter-error-message">
                    <img
                      src={`${imagePrefix}/assets/images/warning-black.svg`}
                      width={17}
                      height={17}
                      className="deals-filter-error-image"
                    />
                    <span> {labels.errors.lbl_deals_filter_error}</span>
                  </CustomContainer>
                </Col>
              </Row>
            )}
            <Row>
              <Col lg={3} xl={3} className="pr1-0">
                <CustomContainer>
                  {isEligible() && (
                    <AffordabilityFilterToggle
                      id="chk_qualify_deals"
                      checkboxLabel={
                        props.isShowAffordDeal
                          ? labels.creditVetting.lbl_qualify
                          : labels.product_affordability.lbl_qualify
                      }
                      checkboxSubtext={props?.upgrade?.creditFilters?.message}
                      handleCheck={handleShowQualifyDeals}
                      check={showQualifyDeals}
                    />
                  )}
                </CustomContainer>
                <CustomContainer>
                  {aggregators?.length > 0 && (
                    <DealGridSearchContainer
                      brands={allBrands}
                      promotions={allPromotions}
                      plantype={plantypes}
                      planname={plannames}
                      accessories={accessories}
                      contractduration={contractDuration}
                      contracttype={contractType}
                      contractsList={contractsList}
                      selectedContractType={selectedFilter?.contracttype}
                      selectedSubCategories={
                        selectedFilter?.selectedSubCategory
                      }
                      selectedCategory={selectedCategory}
                      categoriesList={
                        showComp ? categoryList : filteredCategories
                      }
                      priceValue={priceValue}
                      priceRange={
                        isEligible() && showQualifyDeals
                          ? affordablePriceRange
                          : priceFilterData
                      }
                      missingPriceRange={
                        isEligible() && showQualifyDeals
                          ? missingAffordablePriceRange
                          : missingPriceFilterData
                      }
                      maxPrice={maxPrice}
                      vmValue={selectedFilter?.minutes}
                      airValue={selectedFilter?.airtime}
                      promoValue={selectedFilter?.promo_data}
                      isDealGridPage={true}
                      showQualifyDeals={isEligible() && showQualifyDeals}
                      onPriceChange={handlePriceChange}
                      onBrandChange={handleBrandChange}
                      onPromotionChange={handlePromotionChange}
                      onContractTypeChange={handleContractTypeChange}
                      onPlanTypeChange={handlePlanTypeChange}
                      onPlanNameChange={handlePlanNameChange}
                      onAccessoriesChange={handleAccessoriesChange}
                      onContractDurationChange={handleContractDurationChange}
                      onDataChange={handleDataChange}
                      onAirTimeChange={handleAirTimeChange}
                      onVoiceMinutesChange={handleVoiceMinutesChange}
                      onCategoryChange={handleCategoryChange}
                      onSubCategoryChange={handleSubCategoryChange}
                      onFilterChange={reloadPageData}
                      onFilterReset={handleResetFilter}
                      selectedFilter={selectedFilter}
                      setSelectedFilter={setSelectedFilter}
                      onProductFilterError={handleProductFilterError}
                      onProductFilterChange={handleProductFilterChange}
                      getSelectedPromotion={getSelectedPromotion}
                      getSelectedBrands={getSelectedBrands}
                      getSelectedContractType={getSelectedContractType}
                      getSelectedPlanType={getSelectedPlanType}
                      getSelectedPlanName={getSelectedPlanName}
                      getSelectedContractDuration={getSelectedContractDuration}
                      setPriceValue={() =>
                        setPriceValue({
                          minValue: 0,
                          maxValue: FIXED.MAX_MONTHLY_RECURRING,
                        })
                      }
                      isEligible={isEligible() && showQualifyDeals}
                      productSearchOnDealGridEnabled={
                        props?.productSearchOnDealGridEnabled
                      }
                    />
                  )}
                </CustomContainer>
              </Col>
              {productList &&
              productList.products &&
              productList.products.items ? (
                <Col lg={9} xl={9} className="pl-0">
                  {!props?.upgrade?.upgradeCheckDone &&
                    !props.isShowAffordDeal && (
                      <UpgradeCheckBar
                        id="doAnUpgrade"
                        message={labels.upgrade.lbl_here_to_do_upgrade}
                        btnLabel={labels.upgrade.lbl_do_upgrade}
                        btnHandler={doAnUpgradeCheck}
                        className="mb-3"
                      />
                    )}
                  <DealGridListContainer
                    selectedBrands={selectedFilter?.brands}
                    selectedPromotions={selectedFilter?.promotions}
                    selectedPlantype={selectedFilter?.plantypes}
                    selectedPlanname={selectedFilter?.plannames}
                    selectedAcccessories={selectedFilter?.accessories}
                    selectedContractDuration={selectedFilter?.contractduration}
                    selectedContractType={selectedFilter?.contracttype}
                    selectedSortVal={sortProductsBy}
                    selectedPrice={
                      Number(priceValue?.minValue) > Number(aggMinPrice) ||
                      Number(priceValue?.maxValue) < Number(aggMaxPrice)
                        ? selectedFilter?.monthly_recurring
                        : null
                    }
                    selectedPromoData={
                      Number(selectedFilter?.promo_data?.[0]?.label) >
                        Number(FIXED.MIN_DATA) ||
                      Number(selectedFilter?.promo_data?.[1]?.label) <
                        Number(FIXED.MAX_DATA)
                        ? selectedFilter?.promo_data
                        : null
                    }
                    selectedMinutesData={
                      Number(selectedFilter?.minutes?.[0]?.label) >
                        Number(FIXED.MIN_MINUTES) ||
                      Number(selectedFilter?.minutes?.[1]?.label) <
                        Number(FIXED.MAX_MINUTES)
                        ? selectedFilter?.minutes
                        : null
                    }
                    selectedAirtimeData={
                      Number(selectedFilter?.airtime?.[0]?.label) >
                        Number(FIXED.MIN_AIRTIME) ||
                      Number(selectedFilter?.airtime?.[1]?.label) <
                        Number(FIXED.MAX_AIRTIME)
                        ? selectedFilter?.airtime
                        : null
                    }
                    selectedProducts={selectedFilter?.search}
                    items={productList?.products?.items}
                    isDealGridPage={true}
                    sortBy={handleSortBy}
                    pageInfo={productList.products.page_info}
                    updateCurrentPage={updateCurrentPage}
                    totalItemsCount={productList.products.total_count}
                    bannerData={bannerData}
                    spanXl="4"
                    clearCategories={clearCategorieFilters}
                    showQualifyDeals={isEligible() && showQualifyDeals}
                    defaultUpgrade={isEligible()}
                    onBrandChange={handleBrandChange}
                    onPromotionChange={handlePromotionChange}
                    onContractTypeChange={handleContractTypeChange}
                    onPlanTypeChange={handlePlanTypeChange}
                    onPlanNameChange={handlePlanNameChange}
                    onAccessoriesChange={handleAccessoriesChange}
                    onContractDurationChange={handleContractDurationChange}
                    onFilterChange={reloadPageData}
                    onFilterReset={handleResetFilter}
                    setSelectedFilter={setSelectedFilter}
                    onSeeDetailsClick={handleSeeDetailsClick}
                    onPriceChange={onResetPrice}
                    onProductFilterChange={handleProductFilterChange}
                    originalMax={getMaxPrice()}
                    onDataChange={onResetData}
                    onMinutesChange={onResetMinutes}
                    onAirtimeChange={onResetAirtime}
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
            </Row>
          </CustomContainer>
          <CustomContainer
            className={`${
              showComp ? "" : "mt-3 "
            }spacing-bottom d-block d-lg-none`}
          >
            <Row>
              <Col
                className={
                  (featureSelected === "filter" ||
                    featureSelected == "search") &&
                  "override"
                }
              >
                {(featureSelected === "filter" ||
                  featureSelected === "search") && (
                  <DealGridSearchContainer
                    className="nav-gutter"
                    categoriesList={
                      showComp ? categoryList : filteredCategories
                    }
                    brands={allBrands}
                    promotions={allPromotions}
                    plantype={plantypes}
                    planname={plannames}
                    accessories={accessories}
                    contractduration={contractDuration}
                    contracttype={contractType}
                    contractsList={contractsList}
                    hide={showComp}
                    show={changeState}
                    selectedContractType={selectedFilter?.contracttype}
                    selectedSubCategories={selectedFilter?.selectedSubCategory}
                    selectedCategory={selectedCategory}
                    priceValue={priceValue}
                    priceRange={
                      isEligible() && showQualifyDeals
                        ? affordablePriceRange
                        : priceFilterData
                    }
                    missingPriceRange={
                      isEligible() && showQualifyDeals
                        ? missingAffordablePriceRange
                        : missingPriceFilterData
                    }
                    maxPrice={maxPrice}
                    vmValue={selectedFilter.minutes}
                    airValue={selectedFilter.airtime}
                    promoValue={selectedFilter.promo_data}
                    isDealGridPage={true}
                    showQualifyDeals={isEligible() && showQualifyDeals}
                    onPriceChange={handlePriceChange}
                    onFilterChange={reloadPageData}
                    onFilterReset={handleResetFilter}
                    onBrandChange={handleBrandChange}
                    onPromotionChange={handlePromotionChange}
                    onContractTypeChange={handleContractTypeChange}
                    onPlanTypeChange={handlePlanTypeChange}
                    onPlanNameChange={handlePlanNameChange}
                    onAccessoriesChange={handleAccessoriesChange}
                    onContractDurationChange={handleContractDurationChange}
                    onDataChange={handleDataChange}
                    onAirTimeChange={handleAirTimeChange}
                    onVoiceMinutesChange={handleVoiceMinutesChange}
                    onSubCategoryChange={handleSubCategoryChange}
                    onCategoryChange={handleCategoryChange}
                    selectedFilter={selectedFilter}
                    setSelectedFilter={setSelectedFilter}
                    onProductFilterError={handleProductFilterError}
                    onProductFilterChange={handleProductFilterChange}
                    showProductFilter={showFilterByProduct}
                    getSelectedPromotion={getSelectedPromotion}
                    getSelectedBrands={getSelectedBrands}
                    getSelectedContractType={getSelectedContractType}
                    getSelectedPlanType={getSelectedPlanType}
                    getSelectedPlanName={getSelectedPlanName}
                    getSelectedContractDuration={getSelectedContractDuration}
                    setPriceValue={() => setPriceValue(null)}
                    getSelectedCategory={getSelectedCategory}
                    handleApplyFilter={handleApplyFilter}
                    isEligible={isEligible() && showQualifyDeals}
                    productSearchOnDealGridEnabled={
                      props?.productSearchOnDealGridEnabled
                    }
                  />
                )}
              </Col>
            </Row>
            {productList &&
            productList.products &&
            productList.products.items ? (
              <Row>
                <Col>
                  <DealGridListContainer
                    selectedBrands={selectedFilter?.brands}
                    selectedPromotions={selectedFilter?.promotions}
                    selectedPlantype={selectedFilter?.plantypes}
                    selectedPlanname={selectedFilter?.plannames}
                    selectedAcccessories={selectedFilter?.accessories}
                    selectedContractDuration={selectedFilter?.contractduration}
                    selectedContractType={selectedFilter?.contracttype}
                    selectedSortVal={sortProductsBy}
                    selectedPrice={
                      Number(priceValue?.minValue) > Number(aggMinPrice) ||
                      Number(priceValue?.maxValue) < Number(aggMaxPrice)
                        ? selectedFilter?.monthly_recurring
                        : null
                    }
                    selectedPromoData={
                      Number(selectedFilter?.promo_data?.[0]?.label) >
                        Number(FIXED.MIN_DATA) ||
                      Number(selectedFilter?.promo_data?.[1]?.label) <
                        Number(FIXED.MAX_DATA)
                        ? selectedFilter?.promo_data
                        : null
                    }
                    selectedMinutesData={
                      Number(selectedFilter?.minutes?.[0]?.label) >
                        Number(FIXED.MIN_MINUTES) ||
                      Number(selectedFilter?.minutes?.[1]?.label) <
                        Number(FIXED.MAX_MINUTES)
                        ? selectedFilter?.minutes
                        : null
                    }
                    selectedAirtimeData={
                      Number(selectedFilter?.airtime?.[0]?.label) >
                        Number(FIXED.MIN_AIRTIME) ||
                      Number(selectedFilter?.airtime?.[1]?.label) <
                        Number(FIXED.MAX_AIRTIME)
                        ? selectedFilter?.airtime
                        : null
                    }
                    selectedProducts={selectedFilter?.search}
                    items={productList?.products?.items}
                    isDealGridPage={true}
                    hide={showComp}
                    sortBy={handleSortBy}
                    show={changeState}
                    featureSelected={featureSelected}
                    pageInfo={productList?.products?.page_info}
                    totalItemsCount={productList?.products?.total_count}
                    updateCurrentPage={updateCurrentPage}
                    bannerData={bannerData}
                    clearCategories={clearCategorieFilters}
                    showQualifyDeals={isEligible() && showQualifyDeals}
                    defaultUpgrade={isEligible()}
                    onBrandChange={handleBrandChange}
                    onPromotionChange={handlePromotionChange}
                    onContractTypeChange={handleContractTypeChange}
                    onPlanTypeChange={handlePlanTypeChange}
                    onPlanNameChange={handlePlanNameChange}
                    onAccessoriesChange={handleAccessoriesChange}
                    onContractDurationChange={handleContractDurationChange}
                    onFilterChange={reloadPageData}
                    onFilterReset={handleResetFilter}
                    setSelectedFilter={setSelectedFilter}
                    onSeeDetailsClick={handleSeeDetailsClick}
                    onPriceChange={onResetPrice}
                    onProductFilterChange={handleProductFilterChange}
                    originalMax={getMaxPrice()}
                    onDataChange={onResetData}
                    onMinutesChange={onResetMinutes}
                    onAirtimeChange={onResetAirtime}
                  />
                </Col>
              </Row>
            ) : (
              ""
            )}
          </CustomContainer>
        </Container>

        {props?.sections?.length ? (
          <>
            <CustomContainer
              className={`deal-promotion ${
                !props?.hidePromo ? "d-block" : "d-none"
              }`}
            >
              {props.sections.map((component, index) =>
                renderComponent(component, index)
              )}
            </CustomContainer>
            <CustomContainer
              className={`pb-l ${props?.hidePromo ? "d-block" : "d-none"}`}
            />
          </>
        ) : (
          <CustomContainer className="pb-l" />
        )}
      </CustomContainer>
    </>
  );
};

DealGridPage.propTypes = {
  handleProductRange: PropTypes.func,
  productCompareList: PropTypes.array,
  filterValues: PropTypes.object,
  getFilterDealList: PropTypes.func,
  selectedFilter: PropTypes.object,
  gridId: PropTypes.string,
  sections: PropTypes.array,
  userLoggedIn: PropTypes.bool,
  profileData: PropTypes.any,
  profileLoading: PropTypes.bool,
  hidePromo: PropTypes.bool,
  upgrade: PropTypes.object,
  metadata: PropTypes.object,
  eligibleUpgradeList: PropTypes.array,
  resetDealGrid: PropTypes.bool,
  isShowAffordDeal: PropTypes.bool,
  isSelectedAffordDeal: PropTypes.bool,
  upgradeChecksEnabled: PropTypes.bool,
  defaultCategoryId: PropTypes.any,
  categoryName: PropTypes.string,
  displayHideUpgradeModal: PropTypes.func,
  updateUpgradeRedirect: PropTypes.func,
  displayHideUpgradeTopbanner: PropTypes.func,
  updateJourneyStatus: PropTypes.func,
  updateSelectedData: PropTypes.func,
  updateDealsReset: PropTypes.func,
  toggleFilters: PropTypes.func,
  productSearchOnDealGridEnabled: PropTypes.bool,
};

export const getServerSideProps = async ({ query, resolvedUrl }) => {
  const selectedFilter = await parseFilterQuery(
    decodeURIComponent(resolvedUrl)
  );
  let categoryId = k8sConfig.get("category.dealcategoryid");
  let categoryName = k8sConfig.get("category.dealcategoryName");
  let gridId = k8sConfig.get("products.dealGridId");
  let previewMode = query?.previewMode === "on";
  const gridData = await pageAPI.getPageComponents([
    `${types.DEAL_GRID_PAGE}/CBU${
      query?.previewMode === "on" ||
      query?.toString().includes("previewMode=on")
        ? config.pageServiceQueryData.preview
        : config.pageServiceQueryData.status
    }`,
  ]);

  const upgradeChecksEnabled = k8sConfig.get("features.upgradeChecks");
  const productSearchOnDealGridEnabled = k8sConfig.get(
    "features.productSearchOnDealGrid"
  );
  return {
    props: {
      selectedFilter: {
        ...selectedFilter,
        ...{
          is_deal_product: { eq: "1" },
          is_hidden_product: { eq: "0" },
        },
      },
      metadata: gridData?.seoMetadata || {},
      sections: gridData?.sections || [],
      defaultCategoryId: categoryId,
      previewMode,
      categoryName,
      gridId,
      upgradeChecksEnabled: upgradeChecksEnabled === "true",
      productSearchOnDealGridEnabled: productSearchOnDealGridEnabled === "true",
    },
  };
};

const mapStateToProps = (state) => ({
  hidePromo: state.displayHideFooter.hideFooter,
  profileData: state.navDetails.profileData,
  userLoggedIn: state.navDetails.isUserLoggedIn,
  profileLoading: state.navDetails.isProfileLoading,
  upgrade: state.upgrade,
  upgradeResponse: state.upgrade.upgradeResponse,
  eligibleUpgradeList: state.upgrade.eligibleUpgradeList,
  resetDealGrid: state.upgrade.resetDealGrid,
  isShowAffordDeal: state.creditCheckDetails.isShowAffordDeal,
  isSelectedAffordDeal: state.creditCheckDetails.isSelectedAffordDeal,
});

export default connect(mapStateToProps, {
  displayHideUpgradeModal,
  updateUpgradeRedirect,
  displayHideUpgradeTopbanner,
  updateJourneyStatus,
  updateSelectedData,
  updateDealsReset,
  toggleFilters,
})(withRouter(DealGridPage));
